module.exports = __webpack_public_path__ + "static/fb-ads-614714465ee39f956c3150e7fa4c1796.jpg";